export default {
  getDefaultRecord: ({ recordsType }) => recordsType && recordsType.filter((record) => record.default === true),
  getRecordsType: ({ recordsType }) => (recordsType && recordsType
    .map(({ name, slug, sections, sortOrder, id }) => ({ label: name, slug, sections, sortOrder, id })))
    || [],
}
